﻿import { CookiesStorage, LocalStorage, MultiStorage } from "./BrowserStorage";

export interface ICartProductData {
   PId: number;
   Qty: number;
}

export interface ICartData {
   Version: number;
   TimeStamp?: number;
   Prods?: Array<ICartProductData>;
   ShippingMethodID?: number;
   PaymentMethodID?: number;
   Coupon?: any;
}

const BUCartKey = 'bu-cart';

export class CartStorage {
   private multiStore = new MultiStorage([
      new CookiesStorage(),
      //new LocalStorage()
   ]);

   public save(data?: ICartData): void {
      if (!data || !data.Prods || data.Prods.length === 0) {
         this.multiStore.remove(BUCartKey);
      } else {
         data.TimeStamp = Date.now();
         const jsonData = JSON.stringify(data);

         this.multiStore.set(BUCartKey, jsonData);
      }
   }
   public load(): ICartData {
      const dataArr = this.multiStore.getAll(BUCartKey);
      const jsonArr = new Array<ICartData>();
      dataArr.forEach((el) => {
         const cartData = JSON.parse(el) as ICartData;
         if (cartData && cartData.Version === 2 && cartData.Prods && cartData.Prods.length > 0) jsonArr.push(cartData);
      });
      if (jsonArr.length > 0) {
         jsonArr.sort((a, b) => {
            return (b.TimeStamp ?? 0) - (a.TimeStamp ?? 0);
         });
         return jsonArr[ 0 ];
      }
      return {
         Version: 2
      };
   }

   public clear(): void {
      this.multiStore.remove(BUCartKey);
   }
}